import { render, staticRenderFns } from "./PreviewFullScreenHeader.vue?vue&type=template&id=2ef33665&scoped=true&"
import script from "./PreviewFullScreenHeader.vue?vue&type=script&lang=ts&"
export * from "./PreviewFullScreenHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewFullScreenHeader.vue?vue&type=style&index=0&id=2ef33665&scoped=true&lang=scss&"
import style1 from "./PreviewFullScreenHeader.vue?vue&type=style&index=1&id=2ef33665&scoped=true&lang=css&"
import style2 from "./PreviewFullScreenHeader.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef33665",
  null
  
)

export default component.exports